import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProductDetailPage.css";
import Footer from "./footer";
const token = localStorage.getItem("token");
const API_BASE = process.env.REACT_APP_API_URL || "https://api.goharesadaf.ir";

export default function ProductDetailPage() {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState("next"); // "next" or "prev"
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [relatedLoading, setRelatedLoading] = useState(true);
  const [relatedError, setRelatedError] = useState(null);
  const increaseQuantity = () => setQuantity((q) => Math.min(q + 1, 99));
  const decreaseQuantity = () => setQuantity((q) => Math.max(q - 1, 1));
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [newRating, setNewRating] = useState(0);
  const [loadingComments, setLoadingComments] = useState(true);
  const [commentsError, setCommentsError] = useState(null);
  const [expandedComments, setExpandedComments] = useState(new Set());
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStartX(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchEndX) return;
    const distance = touchStartX - touchEndX;
    const threshold = 50; // minimum swipe distance in px

    if (distance > threshold) {
      // swipe left → next
      prevModal();
    } else if (distance < -threshold) {
      // swipe right → prev
      nextModal();
    }

    setTouchStartX(0);
    setTouchEndX(0);
  };



  useEffect(() => {
    const fetchComments = async () => {
      setLoadingComments(true);
      setCommentsError(null);
      try {
        const res = await fetch(`${API_BASE}/api/comments?commentable_type=Product&commentable_id=${product.id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setComments(data);
      } catch (err) {
        setCommentsError(err.message || "خطا در دریافت نظرات");
      } finally {
        setLoadingComments(false);
      }
    };
    fetchComments();
  }, [product]);

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch(`${API_BASE}/api/products/${productId}`)
      .then((res) => {
        if (!res.ok) throw new Error("محصول یافت نشد");
        return res.json();
      })
      .then((data) => {
        // Ensure main_image is included in images array
        const imgs = Array.isArray(data.images) ? [...data.images] : [];
        if (data.main_image && !imgs.includes(data.main_image)) {
          imgs.unshift(data.main_image);
        }
        data.images = imgs;

        setProduct(data);
        setMainImage(imgs[0] || null);
        setModalIndex(0);
      })
      .catch((err) => setError(err.message || "خطا در دریافت محصول"))
      .finally(() => setLoading(false));
  }, [productId]);

  useEffect(() => {
    // Update modalIndex when mainImage changes
    if (!product || !Array.isArray(product.images)) return;
    const idx = product.images.findIndex((i) => i === mainImage);
    setModalIndex(idx >= 0 ? idx : 0);
  }, [mainImage, product]);
  
  useEffect(() => {
  if (!product?.category?.id) return;

  setRelatedLoading(true);
  setRelatedError(null);

  fetch(`${API_BASE}/api/products/${product.id}/related`)
    .then((res) => {
      if (!res.ok) throw new Error("خطا در دریافت محصولات مرتبط");
      return res.json();
    })
    .then((data) => {
      // Ensure it's always an array
      setRelatedProducts(Array.isArray(data) ? data : data.data ?? []);
    })
    .catch((err) => setRelatedError(err.message || "خطا"))
    .finally(() => setRelatedLoading(false));
}, [product]);

  const toggleExpand = (id) => {
    setExpandedComments(prev => {
      const s = new Set(prev);
      if (s.has(id)) s.delete(id);
      else s.add(id);
      return s;
    });
  };

  const isLongComment = (text) => {
  if (!text) return false;
  // show more if long or contains many line breaks
  return text.length > 260 || (text.match(/\n/g) || []).length >= 4;
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    try {
      const res = await fetch(`${API_BASE}/api/comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          commentable_type: "Product",
          commentable_id: product.id,
          content: newComment,
          rating: newRating || null,
        }),
      });

      if (!res.ok) throw new Error("خطا در ارسال نظر");

      const savedComment = await res.json();
      setComments([savedComment, ...comments]);
      setNewComment("");
      setNewRating(0);
    } catch (err) {
      alert(err.message);
    }
  };

  const handleAddToCart = async (e) => {
    e.stopPropagation();
    if (!product) return;

    if (!token) {
      alert("لطفاً ابتدا وارد حساب کاربری شوید.");
      navigate("/auth");
      return;
    }

    if (!product.active || product.stock < 1) {
      alert("این محصول در حال حاضر موجود نیست.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/cart/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ product_id: product.id, quantity }),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.message || "خطا در افزودن به سبد خرید");
      }

      alert(`محصول "${product.title}" x ${quantity} به سبد خرید اضافه شد!`);
    } catch (err) {
      alert(err.message);
    }
  };
  
const getInitials = (name = "") =>
  name
    .split(" ")
    .map((s) => s.trim()[0] || "")
    .slice(0, 2)
    .join("")
    .toUpperCase();

const fmtDate = (iso) =>
  new Date(iso).toLocaleString("fa-IR", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const ratingCount = comments.filter((c) => c.rating).length;
const averageRating =
  ratingCount > 0
    ? (comments.filter((c) => c.rating).reduce((s, c) => s + Number(c.rating), 0) /
        ratingCount).toFixed(1)
    : null;

  const openModalAt = (index = 0) => {
    setModalIndex(index);
    setIsModalOpen(true);
  };

  const nextModal = useCallback(() => {
    if (!product?.images?.length) return;
    setAnimationDirection("next");
    setAnimating(true);
    setTimeout(() => {
      setModalIndex((i) => (i >= product.images.length - 1 ? 0 : i + 1));
      setAnimating(false);
    }, 300); // duration matches CSS transition
  }, [product]);

  const prevModal = useCallback(() => {
    if (!product?.images?.length) return;
    setAnimationDirection("prev");
    setAnimating(true);
    setTimeout(() => {
      setModalIndex((i) => (i <= 0 ? product.images.length - 1 : i - 1));
      setAnimating(false);
    }, 300);
  }, [product]);


  useEffect(() => {
    const onKey = (e) => {
      if (!isModalOpen) return;
      if (e.key === "Escape") setIsModalOpen(false);
      if (e.key === "ArrowRight") nextModal();
      if (e.key === "ArrowLeft") prevModal();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isModalOpen, nextModal, prevModal]);

  if (loading) {
    return (
      <div className="product-shell-loading">
        <div className="spinner" aria-hidden />
        <p>در حال بارگذاری محصول...</p>
      </div>
    );
  }
  if (error) return <div className="product-shell-error">خطا: {error}</div>;
  if (!product) return <div className="product-shell-error">اطلاعاتی موجود نیست.</div>;

  const specifications = {};
  if (product.dimensions) specifications["ابعاد"] = product.dimensions;
  if (product.material) specifications["جنس"] = product.material;
  if (product.color) specifications["رنگ"] = product.color;

  const inStock = !!product.active && product.stock > 0;
  const hasPrice = product.price !== null && product.price !== undefined && product.price !== "";

  return (
    <div className="product-page">
      <div className="product-detail-page">
        {/* gallery */}
        <aside className="gallery-section" aria-label="گالری تصاویر محصول">
          <div className="main-image-wrap">
            {mainImage ? (
              <img
                src={mainImage}
                alt={product.title}
                className="main-image"
                onClick={() => openModalAt(modalIndex)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && openModalAt(modalIndex)}
              />
            ) : (
              <div className="no-image">تصویری موجود نیست</div>
            )}
          </div>
          {product.discount_percentage > 0 && (
            <div className="discount-badge">
              % {product.discount_percentage.toLocaleString("fa-IR")}
            </div>
          )}
          <div className="thumbnail-row" role="list">
            {product.images && product.images.length > 0 ? (
              product.images.map((img, i) => {
                const selected = mainImage === img;
                return (
                  <button
                    key={i}
                    className={`thumbnail ${selected ? "selected" : ""}`}
                    onClick={() => setMainImage(img)}
                    aria-pressed={selected}
                    title={`نمایش تصویر ${i + 1}`}
                  >
                    <img src={img} alt={`${product.title} ${i + 1}`} />
                  </button>
                );
              })
            ) : (
              <div className="thumb-empty"></div>
            )}
          </div>
        </aside>

        {/* info */}
        <section className="info-section">
{/* breadcrumb */}
<div className="breadcrumb" aria-label="مسیر صفحه">
  {/* Home */}
  <span className="breadcrumb-item">
    <a
      href="/"
      className="breadcrumb-link"
      onClick={(e) => { e.preventDefault(); navigate("/"); }}
    >
      خانه
    </a>
    <span className="breadcrumb-separator">›</span>
  </span>

  {/* Category ancestors (if available) */}
  {product.category?.ancestors && product.category.ancestors.length > 0 ? (
    product.category.ancestors.map((anc, i) => {
      const segs = product.category.ancestors.slice(0, i + 1).map(a => a.slug);
      const path = `/products/${segs.join("/")}`; // e.g. /products/carpet/pictorial-carpet

      const isLast = i === product.category.ancestors.length - 1;
      return (
        <span key={anc.id} className="breadcrumb-item">
          {!isLast ? (
            <>
              <a
                href={path}
                className="breadcrumb-link"
                onClick={(e) => { e.preventDefault(); navigate(path); }}
              >
                {anc.name}
              </a>
              <span className="breadcrumb-separator">›</span>
            </>
          ) : (
            // last category: we still make it clickable to that category page
            <>
              <a
                href={path}
                className="breadcrumb-link"
                onClick={(e) => { e.preventDefault(); navigate(path); }}
              >
                {anc.name}
              </a>
              <span className="breadcrumb-separator">›</span>
            </>
          )}
        </span>
      );
    })
  ) : (
    // fallback if no category info
    product.category ? (
      <span className="breadcrumb-item">
        <a
          href={`/products/${product.category.slug}`}
          className="breadcrumb-link"
          onClick={(e) => { e.preventDefault(); navigate(`/products/${product.category.slug}`); }}
        >
          {product.category.name}
        </a>
        <span className="breadcrumb-separator">›</span>
      </span>
    ) : null
  )}

    {/* product itself */}
    <span className="breadcrumb-item breadcrumb-current" aria-current="page">
      {product.title}
    </span>
  </div>



          <h1 className="product-title">{product.title}</h1>

          <div className="meta-row">
            <div className={`chip ${inStock ? "in" : "out"}`}>
              {inStock ? "موجود در انبار" : "ناموجود"}
            </div>
            <div className="rating-pill">  ⭐ {Number(product.rating_avg)?.toLocaleString("fa-IR") ?? "-"}</div>
            <div className="sku-pill">کد: {product.external_code ?? product.id}</div>
          </div>

          <div className="purchase-section">
            <div className="price-block">
              {hasPrice ? (
                <div className="price">{parseFloat(product.price).toLocaleString("fa-IR")} تومان</div>
              ) : (
                <button
                  className="price-contact"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/contact?product=${product.id}`);
                  }}
                  aria-label="اطلاع از قیمت"
                >
                  اطلاع از قیمت
                </button>
              )}
              <div className="stock-small">{product.stock ?? 0} عدد در انبار</div>
            </div>

            <div className="qty-and-actions">
              <div className="quantity-selector">
                <button onClick={increaseQuantity} disabled={quantity >= 99} aria-label="افزایش تعداد">+</button>
                <input aria-label="تعداد" type="text" value={quantity.toLocaleString("fa-IR")} readOnly />
                <button onClick={decreaseQuantity} disabled={quantity <= 1} aria-label="کاهش تعداد">−</button>
              </div>

              <div className="action-buttons">
                <button
                  className="add-to-cart-btn"
                  onClick={handleAddToCart}
                  disabled={!inStock}
                  aria-disabled={!inStock}
                >
                  افزودن به سبد خرید
                </button>

                <button
                  className="wishlist-link"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/wishlist");
                  }}
                >
                  ❤️ علاقه‌مندی‌ها
                </button>
              </div>
            </div>
          </div>

          {Object.keys(specifications).length > 0 && (
            <div className="specifications">
              <h3>مشخصات محصول</h3>
              <ul>
                {Object.entries(specifications).map(([key, value]) => (
                  <li key={key}>
                    <strong>{key}:</strong> {value}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="description-section">
            <h3>توضیحات</h3>
            <p className="description">{product.description || "بدون توضیحات"}</p>
          </div>

          

          
        </section>
      </div>
<div className="related-products-section">
            <h3>محصولات مرتبط</h3>

            {relatedLoading ? (
              <p>در حال بارگذاری محصولات مرتبط...</p>
            ) : relatedError ? (
              <p className="error">{relatedError}</p>
            ) : relatedProducts.length === 0 ? (
              <p>محصول مرتبطی موجود نیست.</p>
            ) : (
              <div className="related-products-grid">
                {relatedProducts.map((rp) => (
                  <div
                    key={rp.id}
                    className="related-product-card"
                    onClick={() => navigate(`/product/${rp.id}`)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && navigate(`/product/${rp.id}`)}
                  >
                    <img
                      src={rp.main_image || rp.images?.[0] || ""}
                      alt={rp.title}
                      className="related-product-image"
                    />
                    <div className="related-product-info">
                      <h4>{rp.title}</h4>
                      {rp.price && <p>{parseFloat(rp.price).toLocaleString("fa-IR")} تومان</p>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>





          <div className="comments-section" dir="rtl" aria-live="polite">
            <div className="comments-header">
              <h3>نظرات</h3>

              {/* average rating badge */}
              {averageRating ? (
                <div className="avg-rating">
                  <div className="avg-num">۵ / {Number(averageRating)?.toLocaleString("fa-IR") ?? "-"}</div>
                  <div className="avg-stars">
                    <span>{'★'.repeat(Math.round(averageRating))}{'☆'.repeat(5-Math.round(averageRating))}</span>
                    <small>({ratingCount})</small>
                  </div>
                </div>
              ) : (
                <div className="avg-rating no-rating">هنوز امتیازی ثبت نشده است!</div>
              )}
            </div>

            {loadingComments ? (
              <div className="comments-loading">در حال بارگذاری نظرات...</div>
            ) : commentsError ? (
              <div className="comments-error">{commentsError}</div>
            ) : (
              <>
                <div className="add-comment-card">
                  <div className="avatar-col" aria-hidden>
                    <div className="avatar">شما</div>
                  </div>

                  <div className="input-col">
                    <label htmlFor="comment-text" className="sr-only">نظر شما</label>
                    <textarea
                      id="comment-text"
                      placeholder="نظر خود را دربارهٔ این محصول بنویسید..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      className="comment-textarea"
                      maxLength={1000}
                      rows={4}
                      aria-label="نظر"
                    />

                    <div className="bottom-row">
                      <div className="rating-input" role="radiogroup" aria-label="امتیاز شما">
                        <span className="rating-label">امتیاز:</span>
                        <div className="stars" role="presentation">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <button
                              key={star}
                              type="button"
                              className={`star-btn ${star <= newRating ? "filled" : ""}`}
                              onClick={() => setNewRating(star)}
                              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setNewRating(star); }}
                              aria-pressed={star <= newRating}
                              aria-label={`${star} ستاره`}
                            >
                              ★
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="actions">
                        <button
                          className="btn-primary"
                          onClick={handleAddComment}
                          disabled={!newComment.trim()}
                          aria-disabled={!newComment.trim()}
                        >
                          ارسال
                        </button>
                        <button
                          className="btn-ghost"
                          onClick={() => { setNewComment(""); setNewRating(0); }}
                          type="button"
                        >
                          پاک کردن
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="comments-list">
            {comments.length === 0 ? (
              <div className="no-comments">هنوز نظری ثبت نشده است — اولین نفر باشید!</div>
            ) : (
              comments.map((c) => {
                const expanded = expandedComments.has(c.id);
                const long = isLongComment(c.content);

                return (
                  <article
                    key={c.id}
                    className="comment-card"
                    aria-labelledby={`comment-${c.id}-author`}
                  >
                    {/* left column / avatar */}
                    <div className="comment-left" aria-hidden>
                      <div className="comment-avatar">
                        <div className="avatar initials">{getInitials(c.user?.name || "مهمان")}</div>
                      </div>
                    </div>

                    {/* body */}
                    <div className="comment-body">
                      <div className="comment-meta">
                        <div>
                          <h4 id={`comment-${c.id}-author`} className="comment-author">
                            {c.user?.name || "کاربر مهمان"}
                          </h4>
                          {/* small meta for very small screens can be below author if needed */}
                        </div>

                        <div className="comment-meta-right">
                          {c.rating ? (
                            <div className="comment-rating" aria-hidden>
                              <span className="stars-inline">
                                {'★'.repeat(Number(c.rating))}{'☆'.repeat(5 - Number(c.rating))}
                              </span>
                            </div>
                          ) : null}
                          <time className="comment-date" dateTime={c.created_at}>
                            {fmtDate(c.created_at)}
                          </time>
                        </div>
                      </div>

                      {/* content (clamped on mobile via CSS; "expanded" class removes clamp) */}
                      <p className={`comment-content ${expanded ? "expanded" : ""}`}>
                        {c.content}
                      </p>

                      {/* show more / less button when content is long */}
                      {long && (
                        <button
                          className="comment-more"
                          onClick={() => toggleExpand(c.id)}
                          aria-expanded={expanded}
                          aria-controls={`comment-${c.id}-content`}
                        >
                          {expanded ? "نمایش کمتر" : "نمایش بیشتر"}
                        </button>
                      )}
                    </div>
                  </article>
                );
              })
            )}
          </div>

              </>
            )}
          </div>



          
      {/* Image modal / lightbox */}
      {isModalOpen && (
        <div
          className="image-modal"
          role="dialog"
          aria-modal="true"
          onClick={() => setIsModalOpen(false)}
        >
          <button className="modal-close" onClick={() => setIsModalOpen(false)} aria-label="بستن">✕</button>
          {product.images.length > 1 && (
            <>
              <button className="modal-prev" onClick={(e) => { e.stopPropagation(); prevModal(); }} aria-label="عکس قبلی">›</button>
              <button className="modal-next" onClick={(e) => { e.stopPropagation(); nextModal(); }} aria-label="عکس بعدی">‹</button>
            </>
          )}
          <div
            className="modal-inner"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {product.images && product.images[modalIndex] ? (
              <img
                className={`modal-image ${animating ? (animationDirection === "next" ? "slide-next" : "slide-prev") : ""}`}
                src={product.images[modalIndex]}
                alt={`large-${modalIndex}`}
              />
            ) : (
              <div className="modal-empty">هیچ تصویری موجود نیست</div>
            )}
          </div>

        </div>
      )}

      <Footer />
    </div>
  );
}
